export const addTestimonialVideoClickHandlers = () => {
	const buttons = document.querySelectorAll( '.play-testimonial-video a' );

	if ( ! buttons.length ) {
		return;
	}

	const modal = setupModal();
	buttons.forEach( ( button ) => addOnClickListener( button, modal ) );
};

const setupModal = () => {
	const element = document.getElementById( 'testimonial-video-modal' );
	const modal = new bootstrap.Modal( element );
	addDismissHandler( element );
	addShowHandler( element );
	return modal;
};

const addOnClickListener = ( button, modal ) => {
	button.onclick = ( e ) => {
		e.preventDefault();
		modal.show();
	};
};

const addShowHandler = ( modal ) => {
	const iframe = modal.querySelector( 'iframe[data-src]' );
	if ( iframe ) {
		modal.addEventListener( 'show.bs.modal', ( e ) => {
			if ( ! iframe.src ) {
				iframe.setAttribute( 'src', iframe.dataset.src );
			}
		} );
	}
};

const addDismissHandler = ( modal ) => {
	const wrapper = modal.querySelector( '.iframe-wrapper' );
	const html = wrapper.innerHTML;
	modal.addEventListener( 'hidden.bs.modal', ( e ) => {
		wrapper.innerHTML = html;
		const iframe = modal.querySelector( 'iframe[data-src]' );
		if ( ! iframe.src ) {
			iframe.setAttribute( 'src', iframe.dataset.src );
		}
	} );
};
